import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  Form,
  Button,
  Page,
  Layout,
  Select,
  Text,
  Icon,
} from "@shopify/polaris";
import { ToastContext } from "../../global-contexts/Toast";
import { useNavigate } from "react-router-dom";
import useBundlesStore from "../../store/bundle/index";
import { ValidateCoupon } from "../../validators/Coupons";
import BasicCouponDetails from "../../components/Coupons/BasicCouponDetails";
import CouponSettings from "../../components/Coupons/CouponSettings";
import CouponBundleModal from "../../components/Coupons/BundleModal";
import { ArrowLeftIcon } from "@shopify/polaris-icons";

const CouponForm = ({ coupon = null, editable = true, onSubmit, heading }) => {
  const { setToast } = useContext(ToastContext);
  const { bundles } = useBundlesStore();
  // form states
  const [code, setCode] = useState(coupon?.code || "");
  const [title, setTitle] = useState(coupon?.title || "");
  const [discountValue, setDiscountValue] = useState(
    coupon?.discountValue || ""
  );
  const [discountType, setDiscountType] = useState(
    coupon?.discountType || "percentage"
  );
  const [appliesTo, setAppliesTo] = useState(coupon?.appliesTo || "all");
  const [usageLimit, setUsageLimit] = useState(coupon?.usageLimit || "");
  const [appliesOncePerCustomer, setAppliesOncePerCustomer] = useState(
    coupon?.appliesOncePerCustomer || false
  );
  const [startsAt, setStartsAt] = useState(coupon?.startsAt || "");
  const [endsAt, setEndsAt] = useState(coupon?.endsAt || "");
  const [minimumPurchaseAmount, setMinimumPurchaseAmount] = useState(
    coupon?.minimumPurchaseAmount || ""
  );
  const [status, setStatus] = useState(coupon?.status || "active");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedBundles, setSelectedBundles] = useState([]);
  // console.log({  });
  const [modalActive, setModalActive] = useState(false);

  const handleModalToggle = () => setModalActive(!modalActive);
  const navigate = useNavigate();
  const handleBundleSelection = (bundle) => {
    const isSelected = selectedBundles.find(
      (selected) => selected._id === bundle._id
    );
    if (isSelected) {
      setSelectedBundles(
        selectedBundles.filter((selected) => selected._id !== bundle._id)
      );
    } else {
      setSelectedBundles([...selectedBundles, bundle]);
    }
  };
  console.log({ selectedBundles, bundles });
  useEffect(() => {
    console.log({ selectedBundles, bundles });
    if (coupon?.bundleIds) {
      const selected = bundles.filter((b) => coupon.bundleIds.includes(b._id));
      setSelectedBundles(selected);
    }
  }, [coupon]);
  const handleSubmit = async () => {
    setIsSubmitting(true);
    const bundleIds = selectedBundles.map((b) => b._id);
    const couponDetails = {
      code,
      title,
      discountValue,
      discountType,
      appliesTo,
      usageLimit,
      appliesOncePerCustomer,
      startsAt,
      endsAt,
      minimumPurchaseAmount,
      status,
      bundleIds,
    };

    const validationErrors = ValidateCoupon({ coupon: couponDetails });
    if (validationErrors) {
      setToast({
        error: true,
        message: validationErrors.error,
        open: true,
      });
      setIsSubmitting(false);
      return;
    }
    try {
      const { data } = await onSubmit(couponDetails);
      setToast({
        message: data.message,
        error: false,
        open: true,
      });

      setIsSubmitting(false);
      navigate("/coupons");
    } catch (e) {
      setToast({
        error: true,
        message: e.response?.data?.message || "Something went wrong",
        open: true,
      });
      setIsSubmitting(false);
    }
  };

  const statusOptions = [
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
  ];

  const handleCodeChange = (value) => {
    setCode(value.toUpperCase());
  };
  return (
    <Page
      title={
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <div onClick={() => navigate("/coupons")}>
            <Icon tone="primary" source={ArrowLeftIcon} />
          </div>

          <Text as="h1" variant="headingLg">
            {heading}
          </Text>
        </div>
      }
    >
      <Form onSubmit={handleSubmit}>
        <Layout>
          <Layout.Section>
            <BasicCouponDetails
              appliesTo={appliesTo}
              code={code}
              discountType={discountType}
              discountValue={discountValue}
              editable={editable}
              selectedBundles={selectedBundles}
              setAppliesTo={setAppliesTo}
              setCode={handleCodeChange}
              setDiscountType={setDiscountType}
              setDiscountValue={setDiscountValue}
              setTitle={setTitle}
              title={title}
              key={"coupon-basic-details"}
              handleModalToggle={handleModalToggle}
              handleBundleSelection={handleBundleSelection}
              setSelectedBundles={setSelectedBundles}
            />
          </Layout.Section>
          <Layout.Section>
            <CouponSettings
              appliesOncePerCustomer={appliesOncePerCustomer}
              editable={editable}
              endsAt={endsAt}
              minimumPurchaseAmount={minimumPurchaseAmount}
              setAppliesOncePerCustomer={setAppliesOncePerCustomer}
              setEndsAt={setEndsAt}
              setMinimumPurchaseAmount={setMinimumPurchaseAmount}
              setStartsAt={setStartsAt}
              setUsageLimit={setUsageLimit}
              startsAt={startsAt}
              usageLimit={usageLimit}
              key={"coupon-settings"}
            />
          </Layout.Section>
          <Layout.Section>
            <Card title="Status" sectioned>
              <Select
                label="Coupon Status"
                options={statusOptions}
                value={status}
                onChange={setStatus}
                disabled={!editable}
              />
            </Card>
          </Layout.Section>
          <Layout.Section>
            <Button
              disabled={!editable}
              loading={isSubmitting}
              submit
              variant="primary"
            >
              Submit
            </Button>
          </Layout.Section>
        </Layout>
      </Form>
      <CouponBundleModal
        bundles={bundles}
        handleModalToggle={handleModalToggle}
        modalActive={modalActive}
        handleBundleSelection={handleBundleSelection}
        selectedBundles={selectedBundles}
        key={"coupon-bundle-select-modal"}
      />
    </Page>
  );
};

export default CouponForm;
